@if (provider === 'microsoft') {
  <campus-button
    inline
    icon
    class="teams-share-button"
    [attr.data-icon-px-size]="32"
    [attr.data-href]="url"
    [attr.data-msg-text]="'<strong>' + title + '</strong><br />' + body"
    [attr.data-assign-title]="title"
    [attr.data-assign-instr]="body || ''"
  ></campus-button>
}

@if (provider === 'google') {
  <campus-button icon inline>
    <span [id]="shareToClassroomId"></span>
  </campus-button>
}
